import { __jsr } from '~/lib/utils/path_helpers/core';
import { hasOrganizationScopedPaths, splitProjectFullPath } from '~/lib/utils/path_helpers/utils';


/**
 * Generates rails route to
 * /:project_full_path/-/requirements_management/requirements/import_csv(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importCsvProjectRequirementsManagementRequirementsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _importCsvOrganizationNamespaceProjectRequirementsManagementRequirementsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"requirements_management"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[6,"import_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _importCsvNamespaceProjectRequirementsManagementRequirementsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"requirements_management"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[6,"import_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _importCsvOrganizationNamespaceProjectRequirementsManagementRequirementsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _importCsvNamespaceProjectRequirementsManagementRequirementsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/requirements_management/requirements/import_csv/authorize(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const importCsvAuthorizeProjectRequirementsManagementRequirementsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _importCsvAuthorizeOrganizationNamespaceProjectRequirementsManagementRequirementsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"requirements_management"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[6,"import_csv"],[2,[7,"/"],[2,[6,"authorize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _importCsvAuthorizeNamespaceProjectRequirementsManagementRequirementsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"requirements_management"],[2,[7,"/"],[2,[6,"requirements"],[2,[7,"/"],[2,[6,"import_csv"],[2,[7,"/"],[2,[6,"authorize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _importCsvAuthorizeOrganizationNamespaceProjectRequirementsManagementRequirementsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _importCsvAuthorizeNamespaceProjectRequirementsManagementRequirementsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/requirements_management/requirements(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectRequirementsManagementRequirementsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectRequirementsManagementRequirementsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"requirements_management"],[2,[7,"/"],[2,[6,"requirements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectRequirementsManagementRequirementsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"requirements_management"],[2,[7,"/"],[2,[6,"requirements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectRequirementsManagementRequirementsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectRequirementsManagementRequirementsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/automate(/*vueroute)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectAutomatePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAutomatePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"vueroute":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[1,[2,[7,"/"],[5,[3,"vueroute"]]]]]]]]]]]]]]]]);
  const _namespaceProjectAutomatePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"vueroute":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[1,[2,[7,"/"],[5,[3,"vueroute"]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectAutomatePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectAutomatePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/automate/agent-sessions
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectAutomateAgentSessionsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAutomateAgentSessionsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[6,"agent-sessions"]]]]]]]]]]]]]]);
  const _namespaceProjectAutomateAgentSessionsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[6,"agent-sessions"]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectAutomateAgentSessionsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectAutomateAgentSessionsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/automate/agent-sessions/:id
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectAutomateAgentSessionPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAutomateAgentSessionPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[2,[6,"agent-sessions"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]]]]]);
  const _namespaceProjectAutomateAgentSessionPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[2,[6,"agent-sessions"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectAutomateAgentSessionPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectAutomateAgentSessionPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/automate/agents
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectAutomateAgentsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAutomateAgentsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[6,"agents"]]]]]]]]]]]]]]);
  const _namespaceProjectAutomateAgentsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[6,"agents"]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectAutomateAgentsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectAutomateAgentsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/automate/agents/:id
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectAutomateAgentPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAutomateAgentPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]]]]]);
  const _namespaceProjectAutomateAgentPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[2,[6,"agents"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectAutomateAgentPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectAutomateAgentPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/automate/triggers
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectAutomateFlowTriggersPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAutomateFlowTriggersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[6,"triggers"]]]]]]]]]]]]]]);
  const _namespaceProjectAutomateFlowTriggersPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[6,"triggers"]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectAutomateFlowTriggersPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectAutomateFlowTriggersPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/automate/flows
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectAutomateFlowsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAutomateFlowsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[6,"flows"]]]]]]]]]]]]]]);
  const _namespaceProjectAutomateFlowsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[6,"flows"]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectAutomateFlowsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectAutomateFlowsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/automate/flows/:id
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectAutomateFlowPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAutomateFlowPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[2,[6,"flows"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]]]]]);
  const _namespaceProjectAutomateFlowPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[2,[6,"flows"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectAutomateFlowPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectAutomateFlowPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/automate/mcp-servers
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectAutomateMcpServersPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAutomateMcpServersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[6,"mcp-servers"]]]]]]]]]]]]]]);
  const _namespaceProjectAutomateMcpServersPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[6,"mcp-servers"]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectAutomateMcpServersPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectAutomateMcpServersPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/automate/onboarding
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectAutomateOnboardingPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAutomateOnboardingPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[6,"onboarding"]]]]]]]]]]]]]]);
  const _namespaceProjectAutomateOnboardingPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[6,"onboarding"]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectAutomateOnboardingPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectAutomateOnboardingPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/automate/onboarding/initialize
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectAutomateOnboardingInitializePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAutomateOnboardingInitializePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[6,"initialize"]]]]]]]]]]]]]]]]);
  const _namespaceProjectAutomateOnboardingInitializePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[6,"initialize"]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectAutomateOnboardingInitializePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectAutomateOnboardingInitializePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/automate/onboarding/improve_ci
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectAutomateOnboardingImproveCiPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAutomateOnboardingImproveCiPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[6,"improve_ci"]]]]]]]]]]]]]]]]);
  const _namespaceProjectAutomateOnboardingImproveCiPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[6,"improve_ci"]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectAutomateOnboardingImproveCiPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectAutomateOnboardingImproveCiPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/automate/onboarding/initialize_execution_env
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectAutomateOnboardingInitializeExecutionEnvPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAutomateOnboardingInitializeExecutionEnvPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[6,"initialize_execution_env"]]]]]]]]]]]]]]]]);
  const _namespaceProjectAutomateOnboardingInitializeExecutionEnvPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[6,"initialize_execution_env"]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectAutomateOnboardingInitializeExecutionEnvPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectAutomateOnboardingInitializeExecutionEnvPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/automate/onboarding/initialize_mr_review_instructions
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectAutomateOnboardingInitializeMrReviewInstructionsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAutomateOnboardingInitializeMrReviewInstructionsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[6,"initialize_mr_review_instructions"]]]]]]]]]]]]]]]]);
  const _namespaceProjectAutomateOnboardingInitializeMrReviewInstructionsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automate"],[2,[7,"/"],[2,[6,"onboarding"],[2,[7,"/"],[6,"initialize_mr_review_instructions"]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectAutomateOnboardingInitializeMrReviewInstructionsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectAutomateOnboardingInitializeMrReviewInstructionsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/duo_otel_workflows(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectDuoOtelWorkflowsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectDuoOtelWorkflowsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"duo_otel_workflows"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectDuoOtelWorkflowsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"duo_otel_workflows"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectDuoOtelWorkflowsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectDuoOtelWorkflowsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/quality/test_cases(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectQualityTestCasesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectQualityTestCasesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"quality"],[2,[7,"/"],[2,[6,"test_cases"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectQualityTestCasesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"quality"],[2,[7,"/"],[2,[6,"test_cases"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectQualityTestCasesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectQualityTestCasesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/quality/test_cases/new(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newProjectQualityTestCasePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _newOrganizationNamespaceProjectQualityTestCasePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"quality"],[2,[7,"/"],[2,[6,"test_cases"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _newNamespaceProjectQualityTestCasePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"quality"],[2,[7,"/"],[2,[6,"test_cases"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationNamespaceProjectQualityTestCasePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _newNamespaceProjectQualityTestCasePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/quality/test_cases/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectQualityTestCasePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectQualityTestCasePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"quality"],[2,[7,"/"],[2,[6,"test_cases"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectQualityTestCasePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"quality"],[2,[7,"/"],[2,[6,"test_cases"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectQualityTestCasePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectQualityTestCasePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/autocomplete_sources/epics(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const epicsProjectAutocompleteSourcesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _epicsOrganizationNamespaceProjectAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"epics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _epicsNamespaceProjectAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"epics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _epicsOrganizationNamespaceProjectAutocompleteSourcesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _epicsNamespaceProjectAutocompleteSourcesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/autocomplete_sources/iterations(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const iterationsProjectAutocompleteSourcesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _iterationsOrganizationNamespaceProjectAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"iterations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _iterationsNamespaceProjectAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"iterations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _iterationsOrganizationNamespaceProjectAutocompleteSourcesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _iterationsNamespaceProjectAutocompleteSourcesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/autocomplete_sources/vulnerabilities(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const vulnerabilitiesProjectAutocompleteSourcesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _vulnerabilitiesOrganizationNamespaceProjectAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"vulnerabilities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _vulnerabilitiesNamespaceProjectAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"vulnerabilities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _vulnerabilitiesOrganizationNamespaceProjectAutocompleteSourcesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _vulnerabilitiesNamespaceProjectAutocompleteSourcesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/target_branch_rules(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectTargetBranchRulesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectTargetBranchRulesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"target_branch_rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectTargetBranchRulesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"target_branch_rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectTargetBranchRulesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectTargetBranchRulesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/target_branch_rules/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectTargetBranchRulePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectTargetBranchRulePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"target_branch_rules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectTargetBranchRulePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"target_branch_rules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectTargetBranchRulePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectTargetBranchRulePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/comment_templates(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectCommentTemplatesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectCommentTemplatesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"comment_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectCommentTemplatesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"comment_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectCommentTemplatesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectCommentTemplatesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/comment_templates/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectCommentTemplatePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectCommentTemplatePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"comment_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectCommentTemplatePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"comment_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectCommentTemplatePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectCommentTemplatePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/automations(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectAutomationsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAutomationsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectAutomationsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"automations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectAutomationsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectAutomationsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/subscriptions(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectSubscriptionsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSubscriptionsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectSubscriptionsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectSubscriptionsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectSubscriptionsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/subscriptions/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectSubscriptionPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSubscriptionPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSubscriptionPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectSubscriptionPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectSubscriptionPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/get_started/end_tutorial(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const endTutorialProjectGetStartedPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _endTutorialOrganizationNamespaceProjectGetStartedPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"get_started"],[2,[7,"/"],[2,[6,"end_tutorial"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _endTutorialNamespaceProjectGetStartedPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"get_started"],[2,[7,"/"],[2,[6,"end_tutorial"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _endTutorialOrganizationNamespaceProjectGetStartedPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _endTutorialNamespaceProjectGetStartedPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/get_started(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectGetStartedPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectGetStartedPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"get_started"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectGetStartedPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"get_started"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectGetStartedPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectGetStartedPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/learn_gitlab/end_tutorial(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const endTutorialProjectLearnGitlabPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _endTutorialOrganizationNamespaceProjectLearnGitlabPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"learn_gitlab"],[2,[7,"/"],[2,[6,"end_tutorial"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _endTutorialNamespaceProjectLearnGitlabPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"learn_gitlab"],[2,[7,"/"],[2,[6,"end_tutorial"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _endTutorialOrganizationNamespaceProjectLearnGitlabPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _endTutorialNamespaceProjectLearnGitlabPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/learn_gitlab(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectLearnGitlabPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectLearnGitlabPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"learn_gitlab"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectLearnGitlabPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"learn_gitlab"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectLearnGitlabPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectLearnGitlabPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/protected_environments/search(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchProjectProtectedEnvironmentsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _searchOrganizationNamespaceProjectProtectedEnvironmentsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"protected_environments"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _searchNamespaceProjectProtectedEnvironmentsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"protected_environments"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _searchOrganizationNamespaceProjectProtectedEnvironmentsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _searchNamespaceProjectProtectedEnvironmentsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/protected_environments(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectProtectedEnvironmentsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectProtectedEnvironmentsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"protected_environments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectProtectedEnvironmentsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"protected_environments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectProtectedEnvironmentsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectProtectedEnvironmentsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/protected_environments/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectProtectedEnvironmentPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectProtectedEnvironmentPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"protected_environments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectProtectedEnvironmentPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"protected_environments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectProtectedEnvironmentPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectProtectedEnvironmentPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/audit_events(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectAuditEventsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAuditEventsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"audit_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectAuditEventsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"audit_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectAuditEventsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectAuditEventsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/security/dashboard(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectSecurityDashboardIndexPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSecurityDashboardIndexPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSecurityDashboardIndexPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectSecurityDashboardIndexPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectSecurityDashboardIndexPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/security/vulnerability_report(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectSecurityVulnerabilityReportIndexPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSecurityVulnerabilityReportIndexPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"vulnerability_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSecurityVulnerabilityReportIndexPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"vulnerability_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectSecurityVulnerabilityReportIndexPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectSecurityVulnerabilityReportIndexPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/security/compliance_dashboard(/*vueroute)(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectSecurityComplianceDashboardPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSecurityComplianceDashboardPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"vueroute":{},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_dashboard"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSecurityComplianceDashboardPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"vueroute":{},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_dashboard"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectSecurityComplianceDashboardPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectSecurityComplianceDashboardPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/security/compliance_violations/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectSecurityComplianceViolationPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSecurityComplianceViolationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_violations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSecurityComplianceViolationPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"compliance_violations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectSecurityComplianceViolationPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectSecurityComplianceViolationPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/security/agent_artifacts(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectSecurityAgentArtifactsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSecurityAgentArtifactsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"agent_artifacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSecurityAgentArtifactsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"agent_artifacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectSecurityAgentArtifactsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectSecurityAgentArtifactsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/security/policies/schema(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const schemaProjectSecurityPoliciesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _schemaOrganizationNamespaceProjectSecurityPoliciesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"schema"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _schemaNamespaceProjectSecurityPoliciesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"schema"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _schemaOrganizationNamespaceProjectSecurityPoliciesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _schemaNamespaceProjectSecurityPoliciesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/security/policies(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectSecurityPoliciesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSecurityPoliciesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"policies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSecurityPoliciesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"policies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectSecurityPoliciesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectSecurityPoliciesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/security/policies/new(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newProjectSecurityPolicyPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _newOrganizationNamespaceProjectSecurityPolicyPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _newNamespaceProjectSecurityPolicyPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationNamespaceProjectSecurityPolicyPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _newNamespaceProjectSecurityPolicyPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/security/policies/:id/edit(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editProjectSecurityPolicyPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _editOrganizationNamespaceProjectSecurityPolicyPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _editNamespaceProjectSecurityPolicyPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"policies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationNamespaceProjectSecurityPolicyPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _editNamespaceProjectSecurityPolicyPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/security/configuration/corpus_management(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectSecurityConfigurationCorpusManagementPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSecurityConfigurationCorpusManagementPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"corpus_management"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSecurityConfigurationCorpusManagementPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"corpus_management"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectSecurityConfigurationCorpusManagementPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectSecurityConfigurationCorpusManagementPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/security/configuration/api_fuzzing(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectSecurityConfigurationApiFuzzingPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSecurityConfigurationApiFuzzingPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"api_fuzzing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSecurityConfigurationApiFuzzingPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"api_fuzzing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectSecurityConfigurationApiFuzzingPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectSecurityConfigurationApiFuzzingPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/security/configuration/profile_library/dast_site_profiles/new(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newProjectSecurityConfigurationProfileLibraryDastSiteProfilePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _newOrganizationNamespaceProjectSecurityConfigurationProfileLibraryDastSiteProfilePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"profile_library"],[2,[7,"/"],[2,[6,"dast_site_profiles"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);
  const _newNamespaceProjectSecurityConfigurationProfileLibraryDastSiteProfilePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"profile_library"],[2,[7,"/"],[2,[6,"dast_site_profiles"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationNamespaceProjectSecurityConfigurationProfileLibraryDastSiteProfilePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _newNamespaceProjectSecurityConfigurationProfileLibraryDastSiteProfilePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/security/configuration/profile_library/dast_site_profiles/:id/edit(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editProjectSecurityConfigurationProfileLibraryDastSiteProfilePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _editOrganizationNamespaceProjectSecurityConfigurationProfileLibraryDastSiteProfilePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"profile_library"],[2,[7,"/"],[2,[6,"dast_site_profiles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]);
  const _editNamespaceProjectSecurityConfigurationProfileLibraryDastSiteProfilePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"profile_library"],[2,[7,"/"],[2,[6,"dast_site_profiles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationNamespaceProjectSecurityConfigurationProfileLibraryDastSiteProfilePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _editNamespaceProjectSecurityConfigurationProfileLibraryDastSiteProfilePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/security/configuration/profile_library/dast_scanner_profiles/new(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newProjectSecurityConfigurationProfileLibraryDastScannerProfilePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _newOrganizationNamespaceProjectSecurityConfigurationProfileLibraryDastScannerProfilePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"profile_library"],[2,[7,"/"],[2,[6,"dast_scanner_profiles"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);
  const _newNamespaceProjectSecurityConfigurationProfileLibraryDastScannerProfilePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"profile_library"],[2,[7,"/"],[2,[6,"dast_scanner_profiles"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationNamespaceProjectSecurityConfigurationProfileLibraryDastScannerProfilePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _newNamespaceProjectSecurityConfigurationProfileLibraryDastScannerProfilePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/security/configuration/profile_library/dast_scanner_profiles/:id/edit(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editProjectSecurityConfigurationProfileLibraryDastScannerProfilePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _editOrganizationNamespaceProjectSecurityConfigurationProfileLibraryDastScannerProfilePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"profile_library"],[2,[7,"/"],[2,[6,"dast_scanner_profiles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]);
  const _editNamespaceProjectSecurityConfigurationProfileLibraryDastScannerProfilePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"profile_library"],[2,[7,"/"],[2,[6,"dast_scanner_profiles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationNamespaceProjectSecurityConfigurationProfileLibraryDastScannerProfilePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _editNamespaceProjectSecurityConfigurationProfileLibraryDastScannerProfilePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/security/configuration/profile_library(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectSecurityConfigurationProfileLibraryPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSecurityConfigurationProfileLibraryPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"profile_library"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSecurityConfigurationProfileLibraryPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"profile_library"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectSecurityConfigurationProfileLibraryPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectSecurityConfigurationProfileLibraryPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/security/configuration/dast(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectSecurityConfigurationDastPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSecurityConfigurationDastPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"dast"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSecurityConfigurationDastPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"dast"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectSecurityConfigurationDastPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectSecurityConfigurationDastPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/security/configuration/secret_detection(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectSecurityConfigurationSecretDetectionPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSecurityConfigurationSecretDetectionPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"secret_detection"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSecurityConfigurationSecretDetectionPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"configuration"],[2,[7,"/"],[2,[6,"secret_detection"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectSecurityConfigurationSecretDetectionPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectSecurityConfigurationSecretDetectionPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/security/discover(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectSecurityDiscoverPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSecurityDiscoverPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"discover"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSecurityDiscoverPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"discover"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectSecurityDiscoverPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectSecurityDiscoverPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/security/scanned_resources(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectSecurityScannedResourcesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSecurityScannedResourcesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"scanned_resources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSecurityScannedResourcesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"scanned_resources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectSecurityScannedResourcesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectSecurityScannedResourcesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/security/vulnerabilities/:id/discussions(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discussionsProjectSecurityVulnerabilityPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _discussionsOrganizationNamespaceProjectSecurityVulnerabilityPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"vulnerabilities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"discussions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _discussionsNamespaceProjectSecurityVulnerabilityPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"vulnerabilities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"discussions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _discussionsOrganizationNamespaceProjectSecurityVulnerabilityPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _discussionsNamespaceProjectSecurityVulnerabilityPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/security/vulnerabilities/:vulnerability_id/notes(.:format)
 * @param {string} projectFullPath
 * @param {any} vulnerabilityId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectSecurityVulnerabilityNotesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSecurityVulnerabilityNotesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"vulnerability_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"vulnerabilities"],[2,[7,"/"],[2,[3,"vulnerability_id"],[2,[7,"/"],[2,[6,"notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSecurityVulnerabilityNotesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"vulnerability_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"vulnerabilities"],[2,[7,"/"],[2,[3,"vulnerability_id"],[2,[7,"/"],[2,[6,"notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectSecurityVulnerabilityNotesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectSecurityVulnerabilityNotesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/security/vulnerabilities/:vulnerability_id/notes/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} vulnerabilityId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectSecurityVulnerabilityNotePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSecurityVulnerabilityNotePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"vulnerability_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"vulnerabilities"],[2,[7,"/"],[2,[3,"vulnerability_id"],[2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSecurityVulnerabilityNotePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"vulnerability_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"vulnerabilities"],[2,[7,"/"],[2,[3,"vulnerability_id"],[2,[7,"/"],[2,[6,"notes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectSecurityVulnerabilityNotePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectSecurityVulnerabilityNotePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/security/vulnerabilities/new(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newProjectSecurityVulnerabilityPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _newOrganizationNamespaceProjectSecurityVulnerabilityPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"vulnerabilities"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _newNamespaceProjectSecurityVulnerabilityPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"vulnerabilities"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationNamespaceProjectSecurityVulnerabilityPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _newNamespaceProjectSecurityVulnerabilityPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/security/vulnerabilities/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectSecurityVulnerabilityPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSecurityVulnerabilityPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"vulnerabilities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSecurityVulnerabilityPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[6,"vulnerabilities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectSecurityVulnerabilityPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectSecurityVulnerabilityPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/analytics/code_reviews(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectAnalyticsCodeReviewsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAnalyticsCodeReviewsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"code_reviews"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectAnalyticsCodeReviewsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"code_reviews"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectAnalyticsCodeReviewsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectAnalyticsCodeReviewsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/analytics/issues_analytics(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectAnalyticsIssuesAnalyticsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAnalyticsIssuesAnalyticsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"issues_analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectAnalyticsIssuesAnalyticsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"issues_analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectAnalyticsIssuesAnalyticsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectAnalyticsIssuesAnalyticsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/analytics/merge_request_analytics(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectAnalyticsMergeRequestAnalyticsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAnalyticsMergeRequestAnalyticsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"merge_request_analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectAnalyticsMergeRequestAnalyticsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"merge_request_analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectAnalyticsMergeRequestAnalyticsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectAnalyticsMergeRequestAnalyticsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/analytics/dashboards(/*vueroute)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectAnalyticsDashboardsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAnalyticsDashboardsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"vueroute":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"dashboards"],[1,[2,[7,"/"],[5,[3,"vueroute"]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectAnalyticsDashboardsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"vueroute":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"dashboards"],[1,[2,[7,"/"],[5,[3,"vueroute"]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectAnalyticsDashboardsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectAnalyticsDashboardsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/analytics/value_stream_analytics/value_streams(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectAnalyticsCycleAnalyticsValueStreamsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAnalyticsCycleAnalyticsValueStreamsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectAnalyticsCycleAnalyticsValueStreamsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectAnalyticsCycleAnalyticsValueStreamsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectAnalyticsCycleAnalyticsValueStreamsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/analytics/value_stream_analytics/value_streams/new(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newProjectAnalyticsCycleAnalyticsValueStreamPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _newOrganizationNamespaceProjectAnalyticsCycleAnalyticsValueStreamPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _newNamespaceProjectAnalyticsCycleAnalyticsValueStreamPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationNamespaceProjectAnalyticsCycleAnalyticsValueStreamPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _newNamespaceProjectAnalyticsCycleAnalyticsValueStreamPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/analytics/value_stream_analytics/value_streams/:id/edit(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editProjectAnalyticsCycleAnalyticsValueStreamPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _editOrganizationNamespaceProjectAnalyticsCycleAnalyticsValueStreamPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);
  const _editNamespaceProjectAnalyticsCycleAnalyticsValueStreamPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationNamespaceProjectAnalyticsCycleAnalyticsValueStreamPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _editNamespaceProjectAnalyticsCycleAnalyticsValueStreamPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/analytics/value_stream_analytics/value_streams/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectAnalyticsCycleAnalyticsValueStreamPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAnalyticsCycleAnalyticsValueStreamPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectAnalyticsCycleAnalyticsValueStreamPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectAnalyticsCycleAnalyticsValueStreamPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectAnalyticsCycleAnalyticsValueStreamPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/analytics/value_stream_analytics/value_streams/:value_stream_id/stages/:id/average_duration_chart(.:format)
 * @param {string} projectFullPath
 * @param {any} valueStreamId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectAnalyticsCycleAnalyticsAverageDurationChartPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAnalyticsCycleAnalyticsAverageDurationChartPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"value_stream_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"value_stream_id"],[2,[7,"/"],[2,[6,"stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"average_duration_chart"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectAnalyticsCycleAnalyticsAverageDurationChartPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"value_stream_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"value_streams"],[2,[7,"/"],[2,[3,"value_stream_id"],[2,[7,"/"],[2,[6,"stages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"average_duration_chart"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectAnalyticsCycleAnalyticsAverageDurationChartPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectAnalyticsCycleAnalyticsAverageDurationChartPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/analytics/value_stream_analytics/time_summary(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectAnalyticsCycleAnalyticsTimeSummaryPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectAnalyticsCycleAnalyticsTimeSummaryPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"time_summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectAnalyticsCycleAnalyticsTimeSummaryPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"value_stream_analytics"],[2,[7,"/"],[2,[6,"time_summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectAnalyticsCycleAnalyticsTimeSummaryPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectAnalyticsCycleAnalyticsTimeSummaryPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/push_rules/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectPushRulePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectPushRulePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"push_rules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectPushRulePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"push_rules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectPushRulePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectPushRulePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/vulnerability_feedback(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectVulnerabilityFeedbackIndexPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectVulnerabilityFeedbackIndexPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"vulnerability_feedback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectVulnerabilityFeedbackIndexPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"vulnerability_feedback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectVulnerabilityFeedbackIndexPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectVulnerabilityFeedbackIndexPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/vulnerability_feedback/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectVulnerabilityFeedbackPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectVulnerabilityFeedbackPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"vulnerability_feedback"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectVulnerabilityFeedbackPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"vulnerability_feedback"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectVulnerabilityFeedbackPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectVulnerabilityFeedbackPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/vulnerability_feedback/count(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectVulnerabilityFeedbackCountPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectVulnerabilityFeedbackCountPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"vulnerability_feedback"],[2,[7,"/"],[2,[6,"count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectVulnerabilityFeedbackCountPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"vulnerability_feedback"],[2,[7,"/"],[2,[6,"count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectVulnerabilityFeedbackCountPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectVulnerabilityFeedbackCountPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/dependencies/licenses(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const licensesProjectDependenciesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _licensesOrganizationNamespaceProjectDependenciesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"dependencies"],[2,[7,"/"],[2,[6,"licenses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _licensesNamespaceProjectDependenciesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"dependencies"],[2,[7,"/"],[2,[6,"licenses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _licensesOrganizationNamespaceProjectDependenciesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _licensesNamespaceProjectDependenciesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/dependencies(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectDependenciesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectDependenciesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"dependencies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectDependenciesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"dependencies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectDependenciesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectDependenciesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/feature_flags/:feature_flag_iid/issues(.:format)
 * @param {string} projectFullPath
 * @param {any} featureFlagIid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectFeatureFlagIssuesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectFeatureFlagIssuesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"feature_flag_iid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"feature_flags"],[2,[7,"/"],[2,[3,"feature_flag_iid"],[2,[7,"/"],[2,[6,"issues"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectFeatureFlagIssuesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"feature_flag_iid":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"feature_flags"],[2,[7,"/"],[2,[3,"feature_flag_iid"],[2,[7,"/"],[2,[6,"issues"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectFeatureFlagIssuesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectFeatureFlagIssuesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/feature_flags/:feature_flag_iid/issues/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} featureFlagIid
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectFeatureFlagIssuePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectFeatureFlagIssuePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"feature_flag_iid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"feature_flags"],[2,[7,"/"],[2,[3,"feature_flag_iid"],[2,[7,"/"],[2,[6,"issues"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectFeatureFlagIssuePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"feature_flag_iid":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"feature_flags"],[2,[7,"/"],[2,[3,"feature_flag_iid"],[2,[7,"/"],[2,[6,"issues"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectFeatureFlagIssuePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectFeatureFlagIssuePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/feature_flags(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectFeatureFlagsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectFeatureFlagsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"feature_flags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectFeatureFlagsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"feature_flags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectFeatureFlagsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectFeatureFlagsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/feature_flags/new(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newProjectFeatureFlagPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _newOrganizationNamespaceProjectFeatureFlagPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"feature_flags"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _newNamespaceProjectFeatureFlagPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"feature_flags"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationNamespaceProjectFeatureFlagPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _newNamespaceProjectFeatureFlagPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/feature_flags/:iid/edit(.:format)
 * @param {string} projectFullPath
 * @param {any} iid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editProjectFeatureFlagPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _editOrganizationNamespaceProjectFeatureFlagPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"iid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"feature_flags"],[2,[7,"/"],[2,[3,"iid"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _editNamespaceProjectFeatureFlagPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"iid":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"feature_flags"],[2,[7,"/"],[2,[3,"iid"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationNamespaceProjectFeatureFlagPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _editNamespaceProjectFeatureFlagPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/feature_flags/:iid(.:format)
 * @param {string} projectFullPath
 * @param {any} iid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectFeatureFlagPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectFeatureFlagPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"iid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"feature_flags"],[2,[7,"/"],[2,[3,"iid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectFeatureFlagPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"iid":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"feature_flags"],[2,[7,"/"],[2,[3,"iid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectFeatureFlagPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectFeatureFlagPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/on_demand_scans(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectOnDemandScansPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectOnDemandScansPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"on_demand_scans"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectOnDemandScansPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"on_demand_scans"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectOnDemandScansPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectOnDemandScansPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/on_demand_scans/new(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newProjectOnDemandScanPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _newOrganizationNamespaceProjectOnDemandScanPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"on_demand_scans"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _newNamespaceProjectOnDemandScanPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"on_demand_scans"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationNamespaceProjectOnDemandScanPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _newNamespaceProjectOnDemandScanPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/on_demand_scans/:id/edit(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editProjectOnDemandScanPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _editOrganizationNamespaceProjectOnDemandScanPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"on_demand_scans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _editNamespaceProjectOnDemandScanPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"on_demand_scans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationNamespaceProjectOnDemandScanPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _editNamespaceProjectOnDemandScanPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/integrations/jira/issues(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectIntegrationsJiraIssuesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectIntegrationsJiraIssuesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"jira"],[2,[7,"/"],[2,[6,"issues"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectIntegrationsJiraIssuesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"jira"],[2,[7,"/"],[2,[6,"issues"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectIntegrationsJiraIssuesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectIntegrationsJiraIssuesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/integrations/jira/issues/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectIntegrationsJiraIssuePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectIntegrationsJiraIssuePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"jira"],[2,[7,"/"],[2,[6,"issues"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectIntegrationsJiraIssuePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"jira"],[2,[7,"/"],[2,[6,"issues"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectIntegrationsJiraIssuePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectIntegrationsJiraIssuePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/integrations/zentao/issues(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectIntegrationsZentaoIssuesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectIntegrationsZentaoIssuesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"zentao"],[2,[7,"/"],[2,[6,"issues"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectIntegrationsZentaoIssuesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"zentao"],[2,[7,"/"],[2,[6,"issues"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectIntegrationsZentaoIssuesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectIntegrationsZentaoIssuesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/integrations/zentao/issues/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectIntegrationsZentaoIssuePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectIntegrationsZentaoIssuePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"zentao"],[2,[7,"/"],[2,[6,"issues"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectIntegrationsZentaoIssuePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"zentao"],[2,[7,"/"],[2,[6,"issues"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectIntegrationsZentaoIssuePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectIntegrationsZentaoIssuePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/iterations(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectIterationsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectIterationsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"iterations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectIterationsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"iterations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectIterationsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectIterationsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/iterations/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectIterationPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectIterationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"iterations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectIterationPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"iterations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectIterationPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectIterationPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/cadences(/*vueroute)/:iteration_cadence_id/iterations(.:format)
 * @param {string} projectFullPath
 * @param {any} iterationCadenceId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectIterationCadenceIterationsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectIterationCadenceIterationsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"vueroute":{},"iteration_cadence_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[3,"iteration_cadence_id"],[2,[7,"/"],[2,[6,"iterations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectIterationCadenceIterationsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"vueroute":{},"iteration_cadence_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[3,"iteration_cadence_id"],[2,[7,"/"],[2,[6,"iterations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectIterationCadenceIterationsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectIterationCadenceIterationsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/cadences(/*vueroute)/:iteration_cadence_id/iterations/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} iterationCadenceId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectIterationCadenceIterationPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectIterationCadenceIterationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"vueroute":{},"iteration_cadence_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[3,"iteration_cadence_id"],[2,[7,"/"],[2,[6,"iterations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectIterationCadenceIterationPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"vueroute":{},"iteration_cadence_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[3,"iteration_cadence_id"],[2,[7,"/"],[2,[6,"iterations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectIterationCadenceIterationPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectIterationCadenceIterationPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/cadences(/*vueroute)(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectIterationCadencesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectIterationCadencesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"vueroute":{},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);
  const _namespaceProjectIterationCadencesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"vueroute":{},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectIterationCadencesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectIterationCadencesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/cadences(/*vueroute)/new(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newProjectIterationCadencePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _newOrganizationNamespaceProjectIterationCadencePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"vueroute":{},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);
  const _newNamespaceProjectIterationCadencePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"vueroute":{},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationNamespaceProjectIterationCadencePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _newNamespaceProjectIterationCadencePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/cadences(/*vueroute)/:id/edit(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editProjectIterationCadencePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _editOrganizationNamespaceProjectIterationCadencePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"vueroute":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]);
  const _editNamespaceProjectIterationCadencePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"vueroute":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationNamespaceProjectIterationCadencePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _editNamespaceProjectIterationCadencePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/cadences(/*vueroute)/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectIterationCadencePath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectIterationCadencePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"vueroute":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectIterationCadencePath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"vueroute":{},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"cadences"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectIterationCadencePath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectIterationCadencePath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/oncall_schedules(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectIncidentManagementOncallSchedulesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectIncidentManagementOncallSchedulesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"oncall_schedules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectIncidentManagementOncallSchedulesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"oncall_schedules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectIncidentManagementOncallSchedulesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectIncidentManagementOncallSchedulesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/escalation_policies(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectIncidentManagementEscalationPoliciesPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectIncidentManagementEscalationPoliciesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"escalation_policies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectIncidentManagementEscalationPoliciesPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"escalation_policies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectIncidentManagementEscalationPoliciesPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectIncidentManagementEscalationPoliciesPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/settings/work_items(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectSettingsWorkItemsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSettingsWorkItemsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"work_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSettingsWorkItemsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"work_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectSettingsWorkItemsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectSettingsWorkItemsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/settings/gitlab_duo/governance(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectSettingsGitlabDuoGovernanceIndexPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSettingsGitlabDuoGovernanceIndexPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"gitlab_duo"],[2,[7,"/"],[2,[6,"governance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _namespaceProjectSettingsGitlabDuoGovernanceIndexPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"gitlab_duo"],[2,[7,"/"],[2,[6,"governance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectSettingsGitlabDuoGovernanceIndexPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectSettingsGitlabDuoGovernanceIndexPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/secrets(/*vueroute)(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectSecretsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectSecretsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"vueroute":{},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"secrets"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]);
  const _namespaceProjectSecretsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"vueroute":{},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"secrets"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectSecretsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectSecretsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/tracing(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectTracingIndexPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectTracingIndexPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"tracing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectTracingIndexPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"tracing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectTracingIndexPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectTracingIndexPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/tracing/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectTracingPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectTracingPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"tracing"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectTracingPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"tracing"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectTracingPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectTracingPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/metrics(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectMetricsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectMetricsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"metrics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectMetricsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"metrics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectMetricsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectMetricsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/metrics/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectMetricPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectMetricPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"metrics"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _namespaceProjectMetricPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"metrics"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectMetricPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectMetricPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/logs(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectLogsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectLogsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"logs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectLogsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"logs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectLogsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectLogsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/merge_trains(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectMergeTrainsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectMergeTrainsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_trains"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectMergeTrainsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_trains"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectMergeTrainsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectMergeTrainsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/-/transfer_personal(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectTransferPersonalPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectTransferPersonalPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"transfer_personal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectTransferPersonalPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"transfer_personal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectTransferPersonalPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectTransferPersonalPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/path_locks/toggle(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggleProjectPathLocksPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _toggleOrganizationNamespaceProjectPathLocksPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"path_locks"],[2,[7,"/"],[2,[6,"toggle"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _toggleNamespaceProjectPathLocksPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"path_locks"],[2,[7,"/"],[2,[6,"toggle"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _toggleOrganizationNamespaceProjectPathLocksPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _toggleNamespaceProjectPathLocksPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/path_locks(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectPathLocksPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectPathLocksPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"path_locks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _namespaceProjectPathLocksPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"path_locks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectPathLocksPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectPathLocksPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/path_locks/:id(.:format)
 * @param {string} projectFullPath
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectPathLockPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectPathLockPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"path_locks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _namespaceProjectPathLockPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"path_locks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectPathLockPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectPathLockPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/insights/query(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const queryProjectInsightsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _queryOrganizationNamespaceProjectInsightsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"insights"],[2,[7,"/"],[2,[6,"query"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _queryNamespaceProjectInsightsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"insights"],[2,[7,"/"],[2,[6,"query"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _queryOrganizationNamespaceProjectInsightsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _queryNamespaceProjectInsightsPath(namespacePath, projectPath, ...args);
};

/**
 * Generates rails route to
 * /:project_full_path/insights(.:format)
 * @param {string} projectFullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const projectInsightsPath = /*#__PURE__*/ (projectFullPath, ...args) => {
  const _organizationNamespaceProjectInsightsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"insights"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _namespaceProjectInsightsPath = /*#__PURE__*/ __jsr.r({"namespace_id":{"r":true},"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"namespace_id"]],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"insights"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { namespacePath, projectPath } = splitProjectFullPath(projectFullPath);

  if (hasOrganizationScopedPaths()) {
    return _organizationNamespaceProjectInsightsPath(gon.current_organization.path, namespacePath, projectPath, ...args);
  }

  return _namespaceProjectInsightsPath(namespacePath, projectPath, ...args);
};

